/* ═══════════════════════════════════════════════════════════════════
   [D-409] Партнери — компанії, що приводять юзерів за посиланням.

   Назва «Контент Хата» ніде не вшита: це просто перший рядок у списку.
   Другий партнер заводиться тією самою формою, без жодної правки коду.

   🔴 QR тягнемо через api, а не <img src="...">: роут під токеном, і
   голий src отримав би 401. Тому — blob і objectURL, який прибираємо
   за собою, інакше вкладка тихо набирає пам'ять.

   [D-448] Вимога OWNER (05.10): «роби меню зручно так, щоб я не гортав у низ
   шукаючи це меню, а створюй одразу тематичну кнопку для швидкого управління».
   Тому в шапці кожного партнера — ряд кнопок-вкладок, і відкривається лише
   обраний розділ. План і прогрес — videobot-docs/PARTNERS/plan.js.
   ═══════════════════════════════════════════════════════════════════ */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Paper, Typography, TextField, Button, Switch, Chip, Snackbar, Alert, MenuItem,
  Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import api from '../api';
import FeatureRows, { FeatureLegend } from '../components/FeatureRows';   // [D-414]
import { VerChips } from '../components/editorVer';   // [D-697]
import PartnerUserCard from '../components/PartnerUserCard';   // [D-448]; [D-675] термін учня - з сервера (until / active)
import PartnerFinance from '../components/PartnerFinance';   // [D-452] «Фінанси» на підвкладках
import PartnerAppClicks from '../components/PartnerAppClicks';   // [D-548] хто з учнів партнера переходив у застосунки власника
import PartnerCabinetTab from '../components/PartnerCabinetTab';   // [D-458] «Кабінет» на підвкладках
import StudioMusicPage from './StudioMusicPage';
import PartnerSetupGuide, { SetupChip, PartnerTemplatePanel } from '../components/PartnerSetupGuide';   // [D-558] провідник налаштування й еталон функцій
import PartnerHowTo from '../components/PartnerHowTo';   // [D-557] «🧭 Як створити партнера» — покроково
import PartnerAccessMatrix from '../components/PartnerAccessMatrix';
import { usePartnerColors, ColorPick } from '../components/partnerColors';   // [D-599] свій колір кожного партнера   // [D-598] усі картки одним списком, на кожній - партнери
import PartnerPhone from '../components/PartnerPhone';   // [D-687] «📱 Телефон партнера» - його кабінет очима партнера
import PartnerStudioLab from '../components/PartnerStudioLab';   // [D-525]   // [D-507] «🎧 Музика Студії (v-5)» — тепер вкладка «Партнерів»

const C = {
  card: '#16202c',
  line: 'rgba(0,229,160,.22)',
  txt: '#eaf6ff',
  dim: '#a8bece',
  neon: '#00e5a0',
  neonTxt: '#7ffcd3',
  coral: '#ff7a59',
  warn: '#ffb74d',
};

// [D-448] вкладки картки партнера
const TABS = [
  ['main', '⚙️ Основне'],
  ['feats', '🧩 Функції'],
  ['users', '👥 Юзери'],
  ['money', '💶 Фінанси'],
  ['ref', '🎚 Рефералка'],
  ['cab', '🌐 Кабінет'],
  ['phone', '📱 Телефон партнера'],   // [D-687] справжній кабінет партнера, як у нього в телефоні
  ['apps', '📲 Переходи в APP'],   // [D-548]
  ['lab', '🧪 Дозволи і Теми'],   // [D-525] ліворуч дозволи, праворуч Студія v-5 очима учня; «💾 Зберегти тему»
];

const CCY = { UAH: '₴', EUR: '€' };
const fmtMoney = (v, ccy) => (v == null ? '—' : (Math.round(Number(v) * 100) / 100).toLocaleString('uk-UA') + ' ' + (CCY[ccy] || ccy || ''));
const fmtDate = (v) => (v ? new Date(v).toLocaleDateString('uk-UA') : '—');
/* [D-675] OWNER 19.10: «одразу бачити скільки токенів залишилось на рахунку або який пакет коли був куплений зі зворотнім відліком;
   угорі - у кого менше всього строку». Порядок і днів лишилось - із сервера (calc); тут лише показ відліку (оновлюється раз на 30 с). */
const leftTxt = (until, now) => {
  const ms = new Date(until).getTime() - now;
  if (!until || ms <= 0) return null;
  const m = Math.floor(ms / 60000), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60);
  return d >= 1 ? d + ' дн ' + h + ' год' : (h >= 1 ? h + ' год ' + (m % 60) + ' хв' : (m % 60) + ' хв');
};
const stuState = (u, now, K) => {
  if (u.unlimited) return { col: K.ok, badge: '♾ безліміт' };
  const left = leftTxt(u.until, now);
  if (left) return { col: u.left_days <= 2 ? K.bad : (u.left_days <= 7 ? K.warn : K.ok), badge: '⏳ ' + left };
  return u.until ? { col: K.bad, badge: 'закінчився ' + new Date(u.until).toLocaleDateString('uk-UA') } : { col: K.off, badge: 'без доступу' };
};
const pkgLine = (u) => {
  const fd = (v) => new Date(v).toLocaleDateString('uk-UA', { day: '2-digit', month: '2-digit' });
  if (!u.pkg_name) return u.unlimited ? '♾ безліміт' : (u.until ? (u.active ? '🎁 доступ без оплати → ' : '📦 без пакета · був до ') + fd(u.until) : '📦 без пакета');
  return (u.pkg_src === 'trial' ? '🧪 ' : '📦 ') + u.pkg_name + (u.pkg_months ? ' · ' + u.pkg_months + ' міс' : '')
    + (u.pkg_bought_at ? ' · куплено ' + fd(u.pkg_bought_at) : '') + (u.until ? ' → ' + fd(u.until) : '');
};
const STU_F = [['all', 'Усі', () => true], ['pkg', '📦 Пакет', u => !!u.active], ['tok', '🎟 Токени', u => (u.tokens || 0) > 0],
  ['off', '⏸ Без доступу', u => !u.active]];

/* [D-507] OWNER 09.10: «вивести дохід від партнера у згорнуту стрічку партнера в моєму дашборді справа гарно виділивши щоб я одразу
   бачив граючу сумму». Сума «вам» з усіх підтверджених оплат учнів (як у «Фінансах» партнера) — «набирається» від нуля й світиться;
   під нею — скільки за цей місяць. Кілька валют — головна велика, решта дрібно. */
function IncomeBadge({ p }) {
  const inc = p.owner_income || {};
  const ccys = Object.keys(inc).sort((a, b) => (inc[b] || 0) - (inc[a] || 0));
  const main = ccys[0];
  const total = main ? Number(inc[main] || 0) : 0;
  const month = main ? Number((p.owner_income_month || {})[main] || 0) : 0;
  const [shown, setShown] = useState(0);
  useEffect(() => {
    if (!total) { setShown(0); return undefined; }
    let raf = 0; const t0 = performance.now(), dur = 1100;
    const step = (t) => { const k = Math.min(1, (t - t0) / dur); setShown(total * (1 - Math.pow(1 - k, 3))); if (k < 1) raf = requestAnimationFrame(step); };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [total]);
  const has = total > 0;
  return (
    <Box onClick={e => e.stopPropagation()} title="Ваш дохід від партнера: частка «вам» з усіх підтверджених оплат його учнів"
         sx={{ textAlign: 'right', px: 1.4, py: .4, borderRadius: 2, minWidth: 120, cursor: 'default',
               border: '1px solid ' + (has ? 'rgba(255,215,0,.55)' : C.line),
               background: has ? 'linear-gradient(135deg, rgba(255,215,0,.14), rgba(0,229,160,.08))' : 'transparent',
               animation: has ? 'pIncGlow 2.6s ease-in-out infinite' : 'none',
               '@keyframes pIncGlow': { '0%,100%': { boxShadow: '0 0 0 rgba(255,215,0,0)' }, '50%': { boxShadow: '0 0 14px rgba(255,215,0,.45)' } } }}>
      <Typography sx={{ fontSize: 10, color: C.dim, lineHeight: 1.2 }}>{p.coop_started_at ? '💰 вам з оплат' : '🧪 тест · вам з оплат'}</Typography>   {/* [D-623] */}
      <Typography sx={{ fontSize: 19, fontWeight: 800, lineHeight: 1.15, fontVariantNumeric: 'tabular-nums',
                        color: has ? '#FFD700' : C.dim, textShadow: has ? '0 0 10px rgba(255,215,0,.35)' : 'none' }}>
        {fmtMoney(has ? shown : 0, main || 'UAH')}
      </Typography>
      <Typography sx={{ fontSize: 10.5, color: month > 0 ? C.neon : C.dim, lineHeight: 1.2 }}>
        {month > 0 ? '+' + fmtMoney(month, main) + ' цього місяця' : 'цього місяця —'}
        {ccys.slice(1).map(c => ' · ' + fmtMoney(inc[c], c)).join('')}
      </Typography>
    </Box>
  );
}
const thisMonth = () => new Date().toISOString().slice(0, 7);

const fieldSx = { '& .MuiOutlinedInput-notchedOutline': { borderColor: C.line } };
const inProps = { style: { color: C.txt } };
const lblProps = { style: { color: C.dim } };

export default function PartnersPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [toast, setToast] = useState('');
  const [err, setErr] = useState('');
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [tab, setTab] = useState({});            // id -> відкрита вкладка (або нічого)
  const [pageTab, setPageTab] = useState('list');
  const pc = usePartnerColors(rows);   // [D-599] OWNER: «кожному партнеру… різний фоновий колір щоб я на око… розрізняв партнерів»   // [D-507] «🤝 Партнери» | «🎧 Музика Студії (v-5)»
  const [feats, setFeats] = useState({});        // id -> рядки функцій
  const [users, setUsers] = useState({});        // id -> юзери
  const [stuNow, setStuNow] = useState(Date.now());   // [D-675] відлік на картках учнів - раз на 30 с
  useEffect(() => { const t = setInterval(() => setStuNow(Date.now()), 30000); return () => clearInterval(t); }, []);
  const [qr, setQr] = useState({});              // id -> objectURL
  const [cab, setCab] = useState({});            // [D-449] id -> доступи/запрошення/журнал кабінету
  const [uq, setUq] = useState({});              // id -> пошук у юзерах
  const [uf, setUf] = useState({});              // [D-459] id -> фільтр юзерів (all/on/off/new)
  const [bindQ, setBindQ] = useState({});        // [D-559] id -> @нік чи ID клієнта власника, якого переводимо до партнера
  const [bind, setBind] = useState(null);        // [D-559] { p, account, d (відповідь перегляду), notify, busy }
  const [card, setCard] = useState(null);        // { pid, uid } відкрита картка юзера
  const [purge, setPurge] = useState(null);      // [D-467] { p, preview, topics, confirm, busy } — повне видалення партнера
  const [refEdit, setRefEdit] = useState({});    // id -> показати рівні L1–L5
  const [exp, setExp] = useState({});
  const [themes, setThemes] = useState(null);    // [D-474] теми «Посилення» (для «🎨 Теми для учнів»)
  useEffect(() => { api.get('/partner-themes').then(r => setThemes((r.data && r.data.themes) || [])).catch(() => setThemes([])); }, []);            // [D-468] id -> картку партнера розгорнуто (за замовчуванням — згорнуто)

  const detail = (e) => (e.response && e.response.data && e.response.data.detail) || '';
  // [D-559] OWNER 13.10: «є мій старий клієнт… хочу його перевести у v-5». Студію бачать лише учні партнера, а платного клієнта
  // власника посилання партнера не переводить (D-454) — тож переводить сам власник: спершу перегляд, потім підтвердження.
  const bindPreview = (p) => {
    const acc = (bindQ[p.id] || '').trim();
    if (!acc) { setErr('Впишіть @нік або числовий ID клієнта'); return; }
    api.post(`/partners/${p.id}/users/bind`, { account: acc })
      .then(r => setBind({ p, account: acc, d: r.data, notify: false, busy: false }))
      .catch(e => setErr(typeof detail(e) === 'string' && detail(e) ? detail(e) : 'Не вдалося перевірити клієнта'));
  };
  const bindDo = () => {
    if (!bind || bind.busy) return;
    const b = bind;
    setBind(x => ({ ...x, busy: true }));
    api.post(`/partners/${b.p.id}/users/bind`, { account: b.account, confirm: true, notify: !!b.notify })
      .then(r => { setToast(((r.data && r.data.who) || 'Клієнта') + ' переведено до «' + b.p.name + '»'); setBind(null);
                   setBindQ(q => ({ ...q, [b.p.id]: '' })); loadUsers(b.p.id); load(); })
      .catch(e => { setBind(x => (x ? { ...x, busy: false } : x)); setErr(typeof detail(e) === 'string' && detail(e) ? detail(e) : 'Не вдалося перевести'); });
  };
  const failMsg = (e) => 'Не вдалося змінити' + (detail(e) ? ': ' + detail(e) : '');

  const load = () => {
    api.get('/partners')
      .then(r => setRows((r.data && r.data.rows) || []))
      .catch(() => setErr('Не вдалося завантажити список'));
  };
  useEffect(load, []);

  // прибираємо всі objectURL при виході зі сторінки
  useEffect(() => () => {
    Object.keys(qr).forEach(k => { try { URL.revokeObjectURL(qr[k]); } catch (e) {} });
  }, [qr]);

  const create = () => {
    if (!name.trim()) { setErr('Потрібна назва'); return; }
    api.post('/partners', { name, code })
      .then(r => {   // [D-464] гілки в групі створюються одразу
        const t = (r.data && r.data.topics) || {};
        setName(''); setCode('');
        setToast(t.ok ? 'Партнера створено — його гілки вже є у вашій групі' : 'Партнера створено' + (t.why ? ' (гілки: ' + t.why + ')' : ''));
        load();
      })
      .catch(e => setErr(detail(e) || 'Помилка'));
  };

  const patch = (id, data) => {
    return api.post(`/partners/${id}`, data)
      .then(() => { setToast('Збережено'); load(); })
      .catch(e => { setErr(failMsg(e)); throw e; });
  };

  const remove = (p) => {
    if (!window.confirm(`Видалити «${p.name}»? Дію не скасувати.`)) return;
    api.delete(`/partners/${p.id}`)
      .then(() => { setToast('Видалено'); load(); })
      .catch(e => setErr(detail(e) || 'Помилка'));
  };

  const loadFeats = (id) => api.get(`/partners/${id}/features`)
    .then(r => setFeats(s => ({ ...s, [id]: (r.data && r.data.rows) || [] })))
    .catch(() => setFeats(s => ({ ...s, [id]: [] })));
  // [D-448] новачків фіксуємо на ПЕРШОМУ завантаженні (як у «Користувачах»), потім
  // гасимо мітку — інакше 🆕 зникала б з-під руки при кожному оновленні списку
  const [newIds, setNewIds] = useState({});      // id -> Set нових юзерів
  const loadUsers = (id, markSeen) => api.get(`/partners/${id}/users`)
    .then(r => {
      const list = (r.data && r.data.rows) || [];
      setUsers(s => ({ ...s, [id]: list }));
      if (markSeen) {
        // [D-551] повторне завантаження (сервер уже позначив «прочитано») не має стирати 🆕 цього візиту
        setNewIds(s => { const fresh = new Set(list.filter(u => u.is_new).map(u => u.id)); return (fresh.size || !s[id]) ? { ...s, [id]: fresh } : s; });
        if (list.some(u => u.is_new)) {
          api.post(`/partners/${id}/mark-new-seen`).then(load).catch(() => {});
        }
      }
      return list;
    })
    .catch(() => { setUsers(s => ({ ...s, [id]: [] })); return []; });
  /* [D-551] OWNER 13.10: «коли у партнера з'являється новий учень, то в дашборді над меню (Партнери) горить не прочитане сповіщення, але
     коли заходжу в це меню далі не прочитаних ніде немає і стає не зрозуміло де яка дія була виконана — виправи щоб вело саме до
     відкриття нового юзера». Було: дрібний сірий «· 🆕 1» у згорнутому рядку партнера, а новачок — за двома натисками.
     Тепер на вході: знімок «що нового» (жовта панель угорі — лишається на весь візит, хоч сервер уже позначив прочитаним), картка
     партнера з новим учнем сама розгортається на вкладці «👥 Юзери» з фільтром «🆕 Нові», а якщо новий учень один — одразу
     відкривається його картка. Квитанції на підтвердження — тією ж панеллю, кнопка веде у «💶 Фінанси». */
  const [news, setNews] = useState(null);        // знімок на вхід: [{ id, name, n, pay }]
  const autoDone = useRef(false);
  const toPartner = (id) => setTimeout(() => {
    const el = document.querySelector('[data-pt="' + id + '"]');
    if (el && el.scrollIntoView) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }, 300);
  const jumpNew = (p, openOne) => {
    setExp(s => ({ ...s, [p.id]: true }));
    setTab(s => ({ ...s, [p.id]: 'users' }));
    setUf(s => ({ ...s, [p.id]: 'new' }));
    loadUsers(p.id, true).then(list => {
      const fresh = (list || []).filter(u => u.is_new);
      if (openOne && fresh.length === 1) setCard({ pid: p.id, uid: fresh[0].id });
    });
    toPartner(p.id);
  };
  const jumpPay = (p) => {
    setExp(s => ({ ...s, [p.id]: true }));
    setTab(s => ({ ...s, [p.id]: 'money' }));
    toPartner(p.id);
  };
  useEffect(() => {
    if (autoDone.current || !rows.length) return;
    autoDone.current = true;
    setNews(rows.filter(p => (p.new_count || 0) > 0 || (p.sales_pending || 0) > 0)
                .map(p => ({ id: p.id, name: p.name, n: p.new_count || 0, pay: p.sales_pending || 0 })));
    const first = rows.find(p => (p.new_count || 0) > 0);
    if (first) jumpNew(first, true);
  }, [rows]);
  const loadCab = (id) => api.get(`/partners/${id}/cabinet`)
    .then(r => setCab(s => ({ ...s, [id]: r.data })))
    .catch(e => setErr(detail(e) || 'Не вдалося завантажити кабінет'));
  // клік по вкладці: відкриває її (повторний клік — згортає) і довантажує дані
  const openTab = (p, t) => {
    const id = p.id;
    setTab(s => ({ ...s, [id]: s[id] === t ? null : t }));
    if (t === 'feats' && !feats[id]) loadFeats(id);
    if (t === 'users' && (!users[id] || p.new_count > 0)) loadUsers(id, true);
    if (t === 'cab') loadCab(id);
    if (t === 'main' && !qr[id]) {
      api.get(`/partners/${id}/qr`, { responseType: 'blob' })
        .then(r => setQr(s => ({ ...s, [id]: URL.createObjectURL(r.data) })))
        .catch(() => {});
    }
  };

  const setFeat = (id, key, state) => {
    api.post(`/partners/${id}/features?key=${encodeURIComponent(key)}&state=${state}`)
      .then(r => { setFeats(s => ({ ...s, [id]: (r.data && r.data.rows) || [] })); setToast('Збережено'); })
      .catch(e => setErr(failMsg(e)));
  };

  // [D-447] «Закрити весь розділ» — наприклад, усі картки Хаба одним кліком
  const setArea = (id, area, state, title) => {
    // [D-468] '*' — увесь бот; «показати все» відкриває й те, що сховано для всіх (недороблене, застосунки)
    const where = area === '*' ? 'УВЕСЬ бот' : `увесь розділ «${title}»`;
    if (state === 'closed' && !window.confirm(`Сховати ${where} від учнів цього партнера?`)) return;
    if (state === 'open' && area === '*' &&
        !window.confirm('Показати учням УСЕ — і те, що зараз сховано для всіх (недороблені функції, інші застосунки)?\n\nЯкщо треба звичайний набір — «📋 Показати те, що бачать усі».')) return;
    if (state === 'asall' && area === '*' &&
        !window.confirm('Скопіювати партнеру те, що зараз бачать усі: показати те саме, решту сховати?\n\nЦе разово — далі ваші зміни «для всіх» цього партнера не чіпатимуть.')) return;
    api.post(`/partners/${id}/features/area?area=${encodeURIComponent(area)}&state=${state}`)
      .then(r => { setFeats(s => ({ ...s, [id]: (r.data && r.data.rows) || [] })); setToast('Збережено'); })
      .catch(e => setErr(failMsg(e)));
  };

  // [D-468] у нового партнера все сховано — тож перед ввімкненням посилання перевіряємо, що учень
  // не застрягне: зовсім нічого не показано, або сховано оплату чи «Назад/Скасувати»
  const CRIT = ['btn_pay', 'btn_back', 'btn_cancel'];
  const enableLink = (p) => api.get(`/partners/${p.id}/features`).then(r => {
    const rows = (r.data && r.data.rows) || [];
    const shown = rows.filter(f => f.eff_vis).length;
    const crit = rows.filter(f => CRIT.includes(f.key) && !f.eff_vis).map(f => '«' + f.title + '»');
    if (shown === 0) {
      if (!window.confirm('Учням цього партнера зараз сховано ВСЕ — бот для них буде порожнім (ні оплати, ні обробки відео).\n\nВсе одно ввімкнути посилання?')) return;
    } else if (crit.length && !window.confirm(`Учням сховано ${crit.join(', ')} — без цього вони не зможуть оплатити або вийти з кроку.\n\nВсе одно ввімкнути посилання?`)) return;
    patch(p.id, { active: true }).catch(() => {});
  }).catch(() => patch(p.id, { active: true }).catch(() => {}));

  // [D-448] рефералка: вимикаючи, пропонуємо одразу сховати картку «Реферали» в Хабі
  const setRef = (p, on) => {
    patch(p.id, { ref_enabled: on }).then(() => {
      if (!on && window.confirm('Рефералку вимкнено: юзери цього партнера нічого не заробляють.\n\nСховати їм ще й картку «🌳 Реферали» в Хабі?')) {
        setFeat(p.id, 'hub_referrals', 'closed');
      }
    }).catch(() => {});
  };

  const copy = (t) => {
    try { navigator.clipboard.writeText(t); setToast('Скопійовано'); } catch (e) { setErr('Не вийшло'); }
  };

  // [D-418] `label` порожній — підпис тепер у шапці таблиці рівнів
  const Pct = ({ p, k, label }) => (
    <TextField
      size="small" type="number" label={label || undefined}
      defaultValue={p[k] == null ? '' : p[k]}
      onBlur={e => patch(p.id, { [k]: e.target.value }).catch(() => {})}
      inputProps={{ min: 0, max: 25, step: 0.5, style: { color: C.txt, fontWeight: 700 } }}
      InputLabelProps={lblProps}
      sx={{ width: 100, ...fieldSx }}
      placeholder="—"
    />
  );

  const H = ({ children, mt }) => (
    <Typography sx={{ fontSize: 13, color: C.neonTxt, mt: mt == null ? 0 : mt, mb: .8, fontWeight: 700 }}>
      {children}
    </Typography>
  );
  const Hint = ({ children }) => (
    <Typography sx={{ fontSize: 11.5, color: C.dim, mt: .6, maxWidth: 560 }}>{children}</Typography>
  );

  // ── вкладки ────────────────────────────────────────────────────────────
  // [D-460] гілки Telegram для сповіщень партнера
  const tlink = (c, t) => (c ? 'https://t.me/c/' + String(c).replace(/^-100/, '') + '/' + (t || '') : '');
  const saveNotify = (p, which, v, old) => {
    if ((v || '').trim() === (old || '')) return;
    api.post(`/partners/${p.id}/notify`, { [which]: v.trim() })
      .then(() => { setToast(v.trim() ? 'Гілку збережено — натисніть «Перевірити»' : 'Гілку прибрано'); load(); })
      .catch(e => setErr(failMsg(e)));
  };
  // [D-464] група для гілок (спільна для всіх партнерів) і автостворення гілок
  const [grp, setGrp] = useState(null);
  useEffect(() => { api.get('/partner-notify-group').then(r => setGrp(r.data)).catch(() => setGrp({ chat: null })); }, []);
  const saveGroup = (v) => {
    if (!(v || '').trim()) return;
    api.post('/partner-notify-group', { link: v.trim() })
      .then(() => api.get('/partner-notify-group').then(r => { setGrp(r.data); setToast('Групу збережено'); }))
      .catch(e => setErr(failMsg(e)));
  };
  const autoTopics = (p) => api.post(`/partners/${p.id}/notify/auto`)
    .then(() => { setToast('Гілки створено в групі й підключено'); load(); })
    .catch(e => setErr(failMsg(e)));
  const testNotify = (p, which) => api.post(`/partners/${p.id}/notify/test`, { which })
    .then(() => setToast('✅ Повідомлення надіслано — перевірте гілку'))
    .catch(e => setErr(failMsg(e)));
  const deleteStudent = (pid, uid) => {
    if (!window.confirm('Видалити цього учня повністю? Бот забуде його — тим самим Telegram-акаунтом можна знову пройти шлях учня з нуля.\n\nПідтверджені оплати видалити не можна: спершу скасуйте їх у «💶 Фінанси».')) return;
    const ok = () => { setToast('Учня видалено повністю — бот його забув'); setCard(null); loadUsers(pid); load(); };
    api.delete(`/users/${uid}/full_delete`).then(ok).catch(e => {
      // [D-467] є підтверджені оплати → свідомо разом з ними (тести)
      if (e && e.response && e.response.status === 409 &&
          window.confirm('У учня є підтверджені оплати партнеру.\n\nВидалити разом з ними? Вони зникнуть із «Фінансів» і розрахунків.')) {
        api.delete(`/users/${uid}/full_delete?force=true`).then(ok).catch(e2 => setErr(failMsg(e2)));
      } else setErr(failMsg(e));
    });
  };
  // [D-467] повне видалення партнера / усіх його учнів
  const openPurge = (p) => api.get(`/partners/${p.id}/purge-preview`)
    .then(r => setPurge({ p, preview: r.data, topics: 'delete', confirm: '', busy: false }))
    .catch(e => setErr(failMsg(e)));
  const doPurge = () => {
    setPurge(x => ({ ...x, busy: true }));
    api.post(`/partners/${purge.p.id}/purge`, { confirm: purge.confirm.trim(), topics: purge.topics })
      .then(r => {
        const d = r.data || {};
        setToast(`Партнера видалено повністю: учнів ${d.students_deleted}${(d.students_failed || []).length ? ` (не вдалося ${d.students_failed.length})` : ''}`);
        setPurge(null); load();
      })
      .catch(e => { setErr(failMsg(e)); setPurge(x => x && ({ ...x, busy: false })); });
  };
  const purgeStudents = (p) => {
    const v = window.prompt(`Видалити ВСІХ учнів партнера «${p.name}» повністю (з оплатами, налаштуваннями й файлами)?\nПартнер лишається.\n\nДля підтвердження впишіть назву партнера:`);
    if (v === null) return;
    api.post(`/partners/${p.id}/students/purge`, { confirm: v.trim() })
      .then(r => { setToast(`Учнів видалено: ${r.data.deleted}`); loadUsers(p.id); load(); })
      .catch(e => setErr(failMsg(e)));
  };

  // [D-459] «⚙️ Основне» — три картки поруч, а не стовпчик
  const TabMain = (p) => (
    <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: `3px solid ${C.neon}` }}>
        <H>🔗 Посилання для учнів</H>
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
          {qr[p.id] && (
            <img src={qr[p.id]} alt="QR" width={96} height={96} style={{ borderRadius: 8, background: '#fff', padding: 4, flex: 'none' }} />
          )}
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 12.5, color: C.txt, wordBreak: 'break-all' }}>{p.link}</Typography>
            <Box sx={{ display: 'flex', gap: .5, mt: .5 }}>
              <Button size="small" onClick={() => copy(p.link)} sx={{ textTransform: 'none', fontSize: 12, color: C.neon, minWidth: 0 }}>копіювати</Button>
              {qr[p.id] && <Button size="small" component="a" href={qr[p.id]} download={`QR-${p.name}.png`}
                sx={{ textTransform: 'none', fontSize: 12, color: '#4fc3f7', minWidth: 0 }}>⬇ QR</Button>}
            </Box>
          </Box>
        </Box>
        <Hint>{p.active ? 'Працює: учні за ним потрапляють до партнера.' : '⚠️ Партнер вимкнений — посилання поки нікого не закріпить.'}</Hint>
      </Box>
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: '3px solid #4fc3f7' }}>
        <H>✏️ Назва й нотатка</H>
        <TextField size="small" label="Назва" defaultValue={p.name} fullWidth
          onBlur={e => { if (e.target.value.trim() && e.target.value !== p.name) patch(p.id, { name: e.target.value }).catch(() => {}); }}
          InputLabelProps={lblProps} inputProps={inProps} sx={fieldSx} />
        <TextField size="small" label="Нотатка (бачите лише ви)" fullWidth multiline minRows={2}
          defaultValue={p.note || ''}
          onBlur={e => patch(p.id, { note: e.target.value }).catch(() => {})}
          InputLabelProps={lblProps} inputProps={inProps} sx={{ mt: 1.2, ...fieldSx }} />
      </Box>
      {/* [D-474] які теми бачать учні в «Студії» */}
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: `3px solid #b39ddb` }}>
        <H>🎨 Теми для учнів <VerChips vers={['v-4', 'v-5']} /></H>
        <Hint>Кнопки тем у «Студії» учня. Теми й їхні набори функцій («🧩») створюєте в «Посилення» → теми.
          {p.theme_slots == null ? ' Зараз: усі теми.' : ' Обрано: ' + p.theme_slots.length + '.'}</Hint>
        {themes && themes.length === 0 && <Hint>Тем ще немає — створіть у «Посилення».</Hint>}
        <Box sx={{ display: 'flex', gap: .6, flexWrap: 'wrap', mt: 1 }}>
          {(themes || []).map(t => {
            const on = p.theme_slots == null || p.theme_slots.includes(t.slot);
            return (
              <Button key={t.slot} size="small"
                onClick={() => {
                  const all = (themes || []).map(x => x.slot);
                  const cur = p.theme_slots == null ? all : p.theme_slots;
                  const next = on ? cur.filter(x => x !== t.slot) : [...cur, t.slot];
                  patch(p.id, { theme_slots: next.length === all.length && all.every(x => next.includes(x)) ? null : next }).catch(() => {});
                }}
                sx={{ textTransform: 'none', fontSize: 12, borderRadius: 5, border: `1px solid ${on ? '#b39ddb' : C.line}`,
                      color: on ? '#04121a' : C.dim, bgcolor: on ? '#b39ddb' : 'transparent' }}>
                {on ? '✓ ' : ''}{t.name}{t.fx ? ' · 🧩' + Object.keys(t.fx).length : ''}
              </Button>
            );
          })}
        </Box>
      </Box>
      {/* [D-469] «Посилення» для учнів партнера (G15): входить у пакет партнера, межа версій 1–20 */}
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: `3px solid ${C.neon}` }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <H>✨ Посилення для учнів</H><Box sx={{ flex: 1 }} />
          <Switch checked={!!p.hyper_on} onChange={e => patch(p.id, { hyper_on: e.target.checked }).catch(() => {})}
            sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: C.neon }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: C.neon, opacity: .45 } }} />
        </Box>
        <Hint>Учні отримують «Зі спецефектами» без токенів — входить у пакет партнера. Що саме в ньому працює, задаєте
          в «🧩 Функції» → «Посилення».</Hint>
        <Typography sx={{ fontSize: 12.5, color: C.txt, mt: 1, mb: .6 }}>Версій за одне відео — до <b>{p.hyper_versions_max || 3}</b>
          <span style={{ color: C.dim }}> (партнер може зменшити для всіх або учню)</span></Typography>
        <Box sx={{ display: 'grid', gap: .5, gridTemplateColumns: 'repeat(10, 1fr)' }}>
          {Array.from({ length: 20 }, (_, i) => i + 1).map(n => {
            const on = (p.hyper_versions_max || 3) === n;
            return (
              <Button key={n} size="small" onClick={() => patch(p.id, { hyper_versions_max: n }).catch(() => {})}
                sx={{ minWidth: 0, px: 0, py: .2, fontSize: 12, borderRadius: 1.5, border: `1px solid ${C.line}`,
                      color: on ? '#04121a' : C.neonTxt, bgcolor: on ? C.neon : 'transparent', fontWeight: on ? 800 : 400 }}>{n}</Button>
            );
          })}
        </Box>
      </Box>
      {/* [D-750] найдовше відео учнів партнера: власник ставить сам (його ліміт юзеру ще важливіший) і вирішує, чи партнер змінює це в кабінеті */}
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: `3px solid ${C.warn}` }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <H>⏱ Найдовше відео учнів</H><Box sx={{ flex: 1 }} />
          <Typography sx={{ fontSize: 11.5, color: C.dim }}>партнер змінює</Typography>
          <Switch checked={!!p.max_video_on} onChange={e => patch(p.id, { max_video_on: e.target.checked }).catch(() => {})}
            sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: C.warn }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: C.warn, opacity: .45 } }} />
        </Box>
        <Hint>Довше відео бот, Студія й застосунки учням цього партнера не приймуть. Ваш ліміт окремому юзеру (картка юзера → «⏱ Найдовше відео»)
          важливіший; більше за загальний (Налаштування → «⏱ Макс. тривалість») не буде. «Партнер змінює» - те саме поле в його кабінеті
          (нова функція - поки вимкнено всім).</Hint>
        <Box sx={{ display: 'flex', gap: .5, flexWrap: 'wrap', mt: 1 }}>
          {[[0, 'Загальне'], [30, '30 с'], [60, '1 хв'], [90, '1,5 хв'], [120, '2 хв'], [180, '3 хв'], [300, '5 хв'], [600, '10 хв']].map(([v, l]) => {
            const on = (p.max_video_sec || 0) === v;
            return (
              <Button key={v} size="small" onClick={() => patch(p.id, { max_video_sec: v }).catch(() => {})}
                sx={{ minWidth: 0, px: 1, py: .2, fontSize: 12, borderRadius: 1.5, textTransform: 'none', border: `1px solid ${C.line}`,
                      color: on ? '#04121a' : C.neonTxt, bgcolor: on ? C.warn : 'transparent', fontWeight: on ? 800 : 400 }}>{l}</Button>
            );
          })}
        </Box>
        {!!p.max_video_sec && ![30, 60, 90, 120, 180, 300, 600].includes(p.max_video_sec) &&
          <Typography sx={{ fontSize: 12, color: C.warn, mt: .6 }}>Зараз: {p.max_video_sec} с (поставив партнер)</Typography>}
      </Box>
      {/* [D-805] OWNER 01.11: «у партнерів (Функції) залиш… тільки назви функцій… без пояснень по дефолту, а мені в дашборд додай кнопку
          показу або заборони показу пояснень» */}
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: '3px solid #7fd1ff' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <H>📝 Пояснення функцій у кабінеті</H><Box sx={{ flex: 1 }} />
          <Switch data-feat-descr={p.feat_descr_on ? 1 : 0} checked={!!p.feat_descr_on} onChange={e => patch(p.id, { feat_descr_on: e.target.checked }).catch(() => {})}
            sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#7fd1ff' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#7fd1ff', opacity: .45 } }} />
        </Box>
        <Hint>Вимкнено - партнер у «🧩 Функції» бачить лише назви функцій. Увімкнено - і короткі пояснення під кожною.</Hint>
      </Box>
      {/* [D-804] OWNER 01.11: «Партнер може завантажувати ролики у бібліотеку довжиною до 180 секунд але бажано мені в дашборд зробити
          можливість… редагувати якому партнеру… цей показник» - «🧠 СДВГ» (відео фону «Рамки+фон») у його «🎨 Матеріалах» */}
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: '3px solid #b39ddb' }}>
        <H>🧠 СДВГ: найдовший ролик бібліотеки</H>
        <Hint>Ролики для фону теми «🖼 Рамка+фон», які партнер вантажить у «🎨 Матеріали» → «🧠 СДВГ». Типово - 3 хв. Учні беруть їх у Студії
          («🎬 Відео» → «📚 Бібліотека»); своє відео учня - не довше за основне в 1,5 раза (окремому юзеру - у його картці).</Hint>
        <Box sx={{ display: 'flex', gap: .5, flexWrap: 'wrap', mt: 1 }}>
          {[[0, 'Типово (3 хв)'], [30, '30 с'], [60, '1 хв'], [90, '1,5 хв'], [120, '2 хв'], [180, '3 хв'], [300, '5 хв'], [600, '10 хв']].map(([v, l]) => {
            const on = (p.bgvid_max_sec || 0) === v;
            return (
              <Button key={v} size="small" data-bgvid-sec={v} onClick={() => patch(p.id, { bgvid_max_sec: v }).catch(() => {})}
                sx={{ minWidth: 0, px: 1, py: .2, fontSize: 12, borderRadius: 1.5, textTransform: 'none', border: `1px solid ${C.line}`,
                      color: on ? '#04121a' : C.neonTxt, bgcolor: on ? '#b39ddb' : 'transparent', fontWeight: on ? 800 : 400 }}>{l}</Button>
            );
          })}
        </Box>
      </Box>
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: `3px solid ${C.coral}` }}>
        <H>🗑 Видалення</H>
        <Hint>Видаляє партнера й усе повʼязане: учнів (повністю, з оплатами й файлами), фінанси, пакети, кабінет, журнали, ШІ,
          гілки в групі. Бот забуває цих людей — тими самими акаунтами можна пройти все з нуля.</Hint>
        <Button size="small" variant="outlined" onClick={() => openPurge(p)}
          sx={{ mt: 1, textTransform: 'none', color: C.coral, borderColor: C.coral, fontSize: 12.5 }}>🗑 Видалити партнера повністю…</Button>
      </Box>
      <Box sx={{ p: 1.6, borderRadius: 2.5, bgcolor: 'rgba(255,255,255,.03)', borderTop: `3px solid ${C.warn}`, gridColumn: { md: 'span 2' } }}>
        <H>📣 Сповіщення в Telegram — гілки вашої групи</H>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', mb: .5 }}>
          <Typography sx={{ fontSize: 12.5, color: grp && grp.chat ? C.neonTxt : C.warn }}>
            {grp && grp.chat ? `Група: «${grp.title || grp.chat}»${grp.can_topics ? '' : ' · ⚠️ бот не може створювати гілки'}` : 'Групу для гілок не задано'}
          </Typography>
          {(!p.notify_main_chat || !p.notify_users_chat || !p.notify_money_chat) && grp && grp.chat && (   /* [D-473] */
            <Button size="small" variant="contained" onClick={() => autoTopics(p)}
              sx={{ textTransform: 'none', bgcolor: C.neon, color: '#04121a', fontWeight: 700, '&:hover': { bgcolor: '#00c98c' } }}>
              ✨ Створити гілки автоматично
            </Button>
          )}
        </Box>
        {grp && !grp.chat && (
          <TextField size="small" placeholder="посилання на будь-яке повідомлення групи (t.me/c/…)" fullWidth
            onBlur={e => saveGroup(e.target.value)} inputProps={inProps} sx={{ mb: 1, ...fieldSx }} />
        )}
        {[['main', '🤝 Усе про партнера й учнів', 'вхід у кабінет, режим учня, функції учням, публікації учнів…', p.notify_main_chat, p.notify_main_thread],
          ['users', '🆕 Нові учні й квитанції', 'новий учень (імʼя, нік, ID) і квитанції з кнопками ✅ / ❌', p.notify_users_chat, p.notify_users_thread],
          ['money', '💰 Дохід від партнера', 'розрахунки з кнопками «✅ Отримав / ❌ Не отримав», ваші перекази, підсумок кожної оплати: вам / партнеру', p.notify_money_chat, p.notify_money_thread]].map(([w, t, sub, c, th]) => (   /* [D-473] */
          <Box key={w} sx={{ mt: 1 }}>
            <Typography sx={{ color: C.txt, fontSize: 13, fontWeight: 600 }}>{t}</Typography>
            <Typography sx={{ color: C.dim, fontSize: 11.5 }}>{sub}</Typography>
            <Box sx={{ display: 'flex', gap: 1, mt: .5, flexWrap: 'wrap', alignItems: 'center' }}>
              <TextField size="small" placeholder="https://t.me/c/…/…" key={w + p.id + (c || '') + (th || '')} defaultValue={tlink(c, th)}
                onBlur={e => saveNotify(p, w, e.target.value, tlink(c, th))} inputProps={inProps} sx={{ flex: '1 1 260px', ...fieldSx }} />
              <Button size="small" disabled={!c} onClick={() => testNotify(p, w)} sx={{ textTransform: 'none', color: C.neonTxt }}>📨 Перевірити</Button>
            </Box>
          </Box>
        ))}
        <Hint>Новий партнер отримує три гілки в групі автоматично («🤝 Назва», «🆕 Назва — нові учні», «💰 Дохід від «Назва»»); перейменуєте партнера —
          перейменуються й вони, видалите — закриються (історія лишається). Свою гілку можна вставити вручну посиланням.</Hint>
      </Box>
    </Box>
  );

  // [D-459] «🧩 Функції» — розділи кнопками (FeatureRows), одна коротка шапка
  const TabFeats = (p) => (
    <>
      <PartnerTemplatePanel p={p} setToast={setToast} setErr={setErr}
                            onApplied={() => { setFeats(s => ({ ...s, [p.id]: undefined })); loadFeats(p.id); load(); }} />   {/* [D-558] */}
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <Typography sx={{ color: C.dim, fontSize: 12.5 }}>
          Що бачать учні цього партнера. Новий партнер народжується з тими самими функціями, що в еталона (еталона немає — з базовим набором G15).
          Сховане тут партнер у своєму кабінеті <b style={{ color: C.txt }}>не бачить і не вмикає</b>.
        </Typography>
        <FeatureLegend />
      </Box>
      <FeatureRows rows={feats[p.id]} onSet={(k, st) => setFeat(p.id, k, st)} busyKey=""
                   onSetArea={(a, st, t) => setArea(p.id, a, st, t)}
                   ownLabel="для партнера" twoState
                   onPreset={() => {   /* [D-470] */
                     if (!window.confirm('Повернути узгоджений набір G15?\n\nРозділ «Посилення» стане рівно таким, як погоджено; входи «Зі спецефектами», «Без спецефектів», панель у редакторі й /cuts — показано. Інші розділи не зміняться.')) return;
                     api.post(`/partners/${p.id}/features/preset`).then(r => { setFeats(s => ({ ...s, [p.id]: (r.data && r.data.rows) || [] })); setToast('Набір G15 виставлено'); load(); })
                       .catch(e => setErr(failMsg(e)));
                   }} />
    </>
  );

  // [D-459] «👥 Юзери» — фільтри-кнопки, пошук і картки сіткою
  const TabUsers = (p) => {
    const list = users[p.id];
    const q = (uq[p.id] || '').trim().replace(/^@/, '').toLowerCase();
    const now = stuNow;                                       // [D-675] відлік - раз на 30 с
    const isNew = (u) => !!(newIds[p.id] && newIds[p.id].has(u.id));
    const f = uf[p.id] || 'all';
    const FL = [...STU_F, ['new', '🆕 Нові', isNew]];
    const flt = (FL.find(x => x[0] === f) || FL[0])[2];
    const shown = (list || []).filter(u => flt(u) && (!q ||
      (u.telegram_username || '').toLowerCase().includes(q) || String(u.telegram_id || '').includes(q)));
    if (f === 'tok') shown.sort((a, b) => (a.tokens || 0) - (b.tokens || 0));   // у кого менше токенів - угорі
    const K = { ok: C.neon, warn: C.warn, bad: C.coral, off: '#5b6b7a' };
    return (
      <>
        <Box sx={{ display: 'flex', gap: .7, alignItems: 'center', flexWrap: 'wrap', mb: 1.5 }}>
          {(list || []).length > 0 && (   /* [D-467] */
            <Button size="small" onClick={() => purgeStudents(p)} sx={{ textTransform: 'none', color: C.coral, fontSize: 12 }}>🗑 Видалити всіх учнів…</Button>
          )}
          {FL.map(([k, l, fn]) => (
            <Button key={k} size="small" onClick={() => setUf(s => ({ ...s, [p.id]: k }))} variant={f === k ? 'contained' : 'outlined'}
              sx={{ textTransform: 'none', borderRadius: 5, fontSize: 12.5, px: 1.5, borderColor: 'rgba(0,229,160,.25)',
                    color: f === k ? '#04121a' : C.neonTxt, bgcolor: f === k ? C.neon : 'transparent',
                    '&:hover': { bgcolor: f === k ? C.neon : 'rgba(0,229,160,.08)' } }}>
              {l} · {(list || []).filter(fn).length}
            </Button>
          ))}
          <Box sx={{ flex: 1 }} />
          <TextField size="small" placeholder="пошук: @нік або ID" value={uq[p.id] || ''}
            onChange={e => setUq(s => ({ ...s, [p.id]: e.target.value }))}
            inputProps={inProps} sx={{ width: 210, ...fieldSx }} />
          <Button size="small" onClick={() => loadUsers(p.id)} sx={{ textTransform: 'none', color: C.neonTxt, fontSize: 12 }}>⟳</Button>
        </Box>
        {/* [D-559] свого наявного клієнта переводить сам власник: посилання партнера платних клієнтів не чіпає */}
        <Box data-pt-bind={p.id} sx={{ display: 'flex', gap: .8, alignItems: 'center', flexWrap: 'wrap', mb: 1.5, p: 1, borderRadius: 2,
                                      bgcolor: 'rgba(0,229,160,.05)', border: `1px dashed ${C.line}` }}>
          <Typography sx={{ fontSize: 12.5, color: C.txt, flex: 1, minWidth: 230 }}>
            ➕ <b>Перевести мого клієнта до цього партнера</b> — отримає Студію, оплачений доступ лишиться. Спершу покажу, що зміниться.
          </Typography>
          <TextField size="small" placeholder="@нік або ID клієнта" value={bindQ[p.id] || ''}
            onChange={e => { const v = e.target.value; setBindQ(q => ({ ...q, [p.id]: v })); }}
            onKeyDown={e => { if (e.key === 'Enter') bindPreview(p); }}
            inputProps={{ ...inProps, 'data-pt-bind-in': p.id }} sx={{ width: 200, ...fieldSx }} />
          <Button size="small" variant="contained" data-pt-bind-btn={p.id} onClick={() => bindPreview(p)}
            sx={{ textTransform: 'none', bgcolor: C.neon, color: '#04121a', fontWeight: 700, fontSize: 12.5, '&:hover': { bgcolor: C.neon } }}>
            Перевірити…
          </Button>
        </Box>
        {list && list.length === 0 && <Hint>Поки нікого. Учень зʼявляється тут, щойно відкриває бота за посиланням партнера. Свого наявного клієнта переведіть рядком вище.</Hint>}
        {list && list.length > 0 && shown.length === 0 && <Hint>Тут нікого.</Hint>}
        <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))' }}>
          {shown.map(u => {
            const st = stuState(u, now, K);
            return (
              <Box key={u.id} onClick={() => setCard({ pid: p.id, uid: u.id })}
                   data-pt-user={u.id} data-pt-new={isNew(u) ? 1 : 0}
                   sx={{ p: 1.2, borderRadius: 2, cursor: 'pointer', bgcolor: isNew(u) ? 'rgba(255,209,102,.10)' : 'rgba(255,255,255,.03)',
                         outline: isNew(u) ? '2px solid #ffd166' : 'none',   /* [D-551] новий учень видно одразу */
                         borderTop: `3px solid ${st.col}`, '&:hover': { bgcolor: 'rgba(0,229,160,.07)' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                  <Typography sx={{ fontSize: 14, color: C.txt, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {isNew(u) ? '🆕 ' : ''}{u.telegram_username ? '@' + u.telegram_username : 'ID ' + u.telegram_id}
                  </Typography>
                  <Typography data-pt-left="1" sx={{ fontSize: 12.5, fontWeight: 800, color: st.col, whiteSpace: 'nowrap' }}>{st.badge}</Typography>
                </Box>
                <Typography sx={{ fontSize: 12.5, color: u.pkg_name ? C.txt : C.dim, mt: .3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pkgLine(u)}</Typography>
                <Box sx={{ display: 'flex', gap: 1.2, fontSize: 12.5, mt: .3, color: C.dim }}>
                  <span data-pt-tok="1" style={{ color: (u.tokens || 0) > 0 ? '#4fc3f7' : C.dim, fontWeight: (u.tokens || 0) > 0 ? 800 : 400 }}>🎟 {(u.tokens || 0).toLocaleString('uk-UA')}</span>
                  <span>🎬 {u.total_videos || 0}</span>
                  {/* [D-768] переходи в наші застосунки - Андрій саме тут, бо акаунт кабінету партнера
                      у звичайний «Користувачі» не потрапляє (D-448 ховає всіх, у кого є партнер) */}
                  {((u.app_opens || 0) + (u.app_previews || 0)) > 0 && (
                    <span data-pt-ac="1" title="Переходи в наші застосунки" style={{ color: C.neon, fontWeight: 800 }}>👆 {(u.app_opens || 0) + (u.app_previews || 0)}</span>
                  )}
                  <span style={{ marginLeft: 'auto' }}>з {fmtDate(u.created_at)}</span>
                </Box>
              </Box>
            );
          })}
        </Box>
      </>
    );
  };

  // [D-452] «💶 Фінанси» — окремий компонент із підвкладками
  const TabMoney = (p) => (
    <PartnerFinance p={p} onChanged={load} setToast={setToast} setErr={setErr} />
  );

  const TabRef = (p) => {
    const on = !!p.ref_enabled;
    const editing = on || !!refEdit[p.id];
    return (
      <>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, flexWrap: 'wrap' }}>
          <Switch checked={on} onChange={e => setRef(p, e.target.checked)}
            sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: C.neon },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: C.neon, opacity: .45 } }} />
          <Typography sx={{ color: on ? C.neon : C.coral, fontWeight: 700, fontSize: 14 }}>
            {on ? 'Юзери партнера ЗАРОБЛЯЮТЬ на рефералці' : 'Юзери партнера НЕ заробляють на рефералці'}
          </Typography>
          {!on && (
            <Button size="small" onClick={() => setRefEdit(s => ({ ...s, [p.id]: !s[p.id] }))}
              sx={{ textTransform: 'none', color: C.neonTxt, fontSize: 12 }}>
              {refEdit[p.id] ? '▾ сховати рівні' : '✎ Редагувати рівні'}
            </Button>
          )}
        </Box>
        <Hint>
          {on
            ? 'Нарахування йдуть за відсотками нижче (порожнє поле — як у всіх). Діє і в дашборді, і в боті.'
            : 'Вимкнено: з оплат юзерів цього партнера нікому нічого не нараховується, а на сторінці «Реферали» вони бачать 0 %. Рівні можна підготувати заздалегідь — запрацюють, щойно увімкнете.'}
        </Hint>
        {editing && (
          <Box sx={{ mt: 1.5 }}>
            <Box sx={{ display: 'grid', gridTemplateColumns: '58px 104px 1fr', alignItems: 'center', gap: .6, mb: .4 }}>
              <Typography sx={{ fontSize: 11, color: C.dim }}>рівень</Typography>
              <Typography sx={{ fontSize: 11, color: C.dim }}>відсоток</Typography>
              <Typography sx={{ fontSize: 11, color: C.dim }}>видно юзерам</Typography>
            </Box>
            {[1, 2, 3, 4, 5].map(n => {
              const ks = 'show_l' + n;
              const shown = n === 1 || p[ks] !== false;
              return (
                <Box key={n} sx={{ display: 'grid', gridTemplateColumns: '58px 104px 1fr', alignItems: 'center', gap: .6, py: .2 }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: shown ? C.neonTxt : '#6e8195' }}>L{n}</Typography>
                  <Pct p={p} k={'ref_l' + n} label="" />
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: .5 }}>
                    <Switch size="small" checked={shown} disabled={n === 1}
                      onChange={e => patch(p.id, { [ks]: e.target.checked }).catch(() => {})}
                      sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: C.neon },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: C.neon, opacity: .45 } }} />
                    <Typography sx={{ fontSize: 11, color: shown ? C.neon : C.coral }}>
                      {n === 1 ? 'видно завжди' : (shown ? 'видно' : 'приховано')}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
            <Hint>
              Порожній відсоток — діє загальний, а не нуль. Кола вкладені одне в одне, тому закритий рівень
              обрізає і все, що під ним. Перший рівень видно завжди: без нього юзер не побачить навіть тих,
              кого привів сам.
            </Hint>
            <TextField size="small" label="Беніфіціар (id юзера)"
              defaultValue={p.user_id == null ? '' : p.user_id}
              onBlur={e => patch(p.id, { user_id: e.target.value }).catch(() => {})}
              InputLabelProps={lblProps} inputProps={inProps}
              sx={{ width: 200, mt: 1.4, ...fieldSx }} />
            <Hint>Кому капають реферальні гроші партнера: без беніфіціара посилання працює, але виплат не буде.</Hint>
          </Box>
        )}
      </>
    );
  };

  // [D-458] «🌐 Кабінет» — окремий компонент із розділами-кнопками
  const TabCab = (p) => (
    <PartnerCabinetTab p={p} d={cab[p.id]} reload={() => loadCab(p.id)} onChanged={load} setToast={setToast} setErr={setErr} />
  );

  // [D-525] «🧪 Дозволи і Теми» — окремим повноекранним вікном
  const TabLab = (p) => (
    <PartnerStudioLab p={p} setToast={setToast} setErr={setErr} onChanged={() => setFeats(s => ({ ...s, [p.id]: undefined }))}
                      onClose={() => setTab(s => ({ ...s, [p.id]: null }))} />
  );

  const TabApps = (p) => <PartnerAppClicks p={p} />;   // [D-548]
  const TabPhone = (p) => <PartnerPhone key={'pphone' + p.id} p={p} C={C} />;   // [D-687]
  const BODY = { main: TabMain, feats: TabFeats, users: TabUsers, money: TabMoney, ref: TabRef, cab: TabCab, phone: TabPhone, apps: TabApps, lab: TabLab };

  return (
    <Box sx={{ p: 2, maxWidth: 1080 }}>
      <Typography variant="h5" sx={{ color: C.txt, mb: .5, fontWeight: 700 }}>
        🤝 Партнери
      </Typography>
      {/* [D-507] OWNER: «Музика студії v-5 — це меню треба перенести до меню (Партнери)» — вкладки-кнопки, одна тема на екрані */}
      <Box sx={{ display: 'flex', gap: .8, mb: 1.5, flexWrap: 'wrap' }}>
        {[['list', '🤝 Партнери'], ['access', '🧩 Функції / дозволи / набори / теми'], ['music', '🎧 Музика Студії (v-5)'], ['howto', '🧭 Як створити партнера']].map(([k, lbl]) => (   /* [D-598] */
          <Button key={k} size="small" data-page-tab={k} onClick={() => setPageTab(k)} variant={pageTab === k ? 'contained' : 'outlined'}
            sx={{ textTransform: 'none', fontSize: 13, borderRadius: 5, px: 1.8, borderColor: C.line,
                  color: pageTab === k ? '#04121a' : C.neonTxt, bgcolor: pageTab === k ? C.neon : 'transparent',
                  '&:hover': { bgcolor: pageTab === k ? C.neon : 'rgba(0,229,160,.08)', borderColor: C.neon } }}>{lbl}</Button>
        ))}
      </Box>
      {pageTab === 'howto' ? <PartnerHowTo /> : pageTab === 'music' ? <StudioMusicPage /> : pageTab === 'access' ? <PartnerAccessMatrix /> : (<>
      <Typography sx={{ fontSize: 12.5, color: C.dim, mb: 2 }}>
        Компанії, що приводять юзерів за своїм посиланням. Кожен партнер має власні функції, ціну,
        розподіл прибутку й своїх юзерів — вони не змішуються з вкладкою «Користувачі».
      </Typography>

      <Paper sx={{ bgcolor: C.card, border: `1px solid ${C.line}`, p: 2, mb: 3, backgroundImage: 'none' }}>
        <Typography sx={{ color: C.neonTxt, fontSize: 14, mb: 1.5 }}>Новий партнер</Typography>
        <Box sx={{ display: 'flex', gap: 1.2, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField size="small" label="Назва" value={name}
            onChange={e => setName(e.target.value)}
            InputLabelProps={lblProps} inputProps={inProps}
            sx={{ width: 240, ...fieldSx }} />
          <TextField size="small" label="Код для посилання" value={code}
            onChange={e => setCode(e.target.value)}
            placeholder="contenthata"
            InputLabelProps={lblProps} inputProps={inProps}
            sx={{ width: 220, ...fieldSx }} />
          <Button variant="contained" onClick={create}
            sx={{ bgcolor: C.neon, color: '#04121a', textTransform: 'none', fontWeight: 700 }}>
            Створити
          </Button>
        </Box>
        <Typography sx={{ fontSize: 11.5, color: C.dim, mt: 1.2 }}>
          Код іде в посилання, тому тільки латиниця, цифри й підкреслення —
          решту приберемо самі. Після створення код не міняється: він уже на
          QR і в роздрукованих матеріалах.
          <br />Новий партнер з'являється <b style={{ color: C.coral }}>чернеткою</b>:
          посилання й QR видно одразу, але бот за ними нікого не прив'яже, доки
          ви не налаштуєте доступ і не натиснете «Увімкнути».
          <br />Новий партнер одразу отримує <b style={{ color: C.neon }}>ті самі функції, що в еталонного партнера</b> (у списку він із позначкою «📌 еталон»);
          решта <b style={{ color: C.coral }}>схована</b>. Далі в рядку партнера веде «🧭 Провідник»: показує, що вже зроблено, і блимає на кнопці, яку натиснути.
        </Typography>
      </Paper>

      {news && news.length > 0 && (   /* [D-551] куди дивитись: нові учні й квитанції, по партнерах */
        <Paper data-pt-news="1" sx={{ bgcolor: 'rgba(255,209,102,.08)', border: '1px solid #ffd166', p: 1.4, mb: 1.6, backgroundImage: 'none' }}>
          <Typography sx={{ color: '#ffd166', fontWeight: 800, fontSize: 14, mb: .8 }}>🔔 Що нового в партнерів</Typography>
          <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))' }}>
            {news.map(x => {
              const p = rows.find(r => r.id === x.id);
              if (!p) return null;
              const bsx = { display: 'block', width: '100%', textAlign: 'left', textTransform: 'none', fontSize: 13, fontWeight: 700, mt: .5, borderRadius: 2,
                            color: '#1b1300', bgcolor: '#ffd166', '&:hover': { bgcolor: '#ffc233' } };
              return (
                <Box key={x.id} sx={{ p: 1.1, borderRadius: 2, bgcolor: 'rgba(255,255,255,.04)' }}>
                  <Typography sx={{ color: C.txt, fontWeight: 700, fontSize: 13.5 }}>🤝 {x.name}</Typography>
                  {x.n > 0 && <Button data-pt-jump={x.id} size="small" onClick={() => jumpNew(p, false)} sx={bsx}>🆕 нових учнів: {x.n} — показати</Button>}
                  {x.pay > 0 && <Button data-pt-pay={x.id} size="small" onClick={() => jumpPay(p)} sx={bsx}>💳 квитанцій на підтвердження: {x.pay} — відкрити</Button>}
                </Box>
              );
            })}
          </Box>
        </Paper>
      )}

      {rows.length === 0 ? (
        <Typography sx={{ color: C.dim, fontSize: 13 }}>Партнерів ще немає.</Typography>
      ) : (   /* [D-468] скільки всього; картки — згорнуті, натиск розгортає */
        <Typography sx={{ color: C.txt, fontSize: 14, fontWeight: 700, mb: 1.2 }}>
          Партнерів: {rows.length}
          <span style={{ color: C.dim, fontWeight: 400, fontSize: 12.5 }}>
            {' '}· працює {rows.filter(p => p.active).length} · чернеток {rows.filter(p => !p.active).length}
          </span>
        </Typography>
      )}

      {rows.map(p => {
        const t = tab[p.id];
        const isOpen = !!exp[p.id];
        // [D-468] коротка інформація в один рядок — видно й у згорнутому стані
        const facts = [
          ['📅', 'створено ' + fmtDate(p.created_at)],
          ['👥', p.users_count + ' учн.' + (p.new_count > 0 ? ` · 🆕 нових: ${p.new_count}` : ''), p.new_count > 0 ? '#ffd166' : null],   // [D-551]
          p.sales_pending > 0 ? ['💳', p.sales_pending + ' чекає підтвердження', C.warn] : null,
          ['🧩', `показано ${p.feats_shown || 0} з ${p.feats_total || 0}`, (p.feats_shown || 0) === 0 ? C.coral : null],
        ].filter(Boolean);
        return (
          <Paper key={p.id} data-pt={p.id} data-pt-color={pc.color(p.id)} sx={{ bgcolor: C.card, border: `1px solid ${p.new_count > 0 ? '#ffd166' : p.active ? C.line : '#3a3a3a'}`,
                                  borderLeft: `6px solid ${pc.color(p.id)}`,   /* [D-599] */
                                  p: isOpen ? 2 : 1.2, px: 2, mb: isOpen ? 2 : 1, backgroundImage: `linear-gradient(90deg, ${pc.color(p.id)}2e 0%, ${C.card} 55%)` }}>
            <Box onClick={() => setExp(s => ({ ...s, [p.id]: !s[p.id] }))}
                 sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', cursor: 'pointer', userSelect: 'none' }}>
              <Typography sx={{ color: C.dim, fontSize: 13, width: 14 }}>{isOpen ? '▾' : '▸'}</Typography>
              <Typography sx={{ color: p.active ? C.txt : C.dim, fontSize: 16, fontWeight: 700 }}>
                {p.name}
              </Typography>
              <ColorPick color={pc.color(p.id)} onPick={(c) => pc.set(p.id, c).then(() => setToast(`${p.name}: колір збережено`)).catch(() => setErr('Не вдалося зберегти колір'))} />
              {/* [D-410] Чернетка — щоб не видати посилання раніше, ніж
                  налаштовано, що партнер бачить у боті. */}
              <Chip size="small" label={p.active ? '● працює' : '✎ чернетка'}
                sx={{ bgcolor: 'transparent', color: p.active ? C.neon : C.coral,
                      border: `1px solid ${p.active ? C.neon : C.coral}` }} />
              {p.is_template && <Chip size="small" data-pt-tpl="1" label="📌 еталон" title="Нові партнери народжуються з такими самими функціями"
                sx={{ bgcolor: 'transparent', color: C.neonTxt, border: `1px solid ${C.line}` }} />}
              {!isOpen && <SetupChip s={p.setup} />}   {/* [D-558] на якому кроці налаштування */}
              {/* [D-452] пакети партнера: кількість і найнижча ціна */}
              {(p.packages || []).length > 0 && (
                <Chip size="small"
                  label={'📦 ' + p.packages.length + (p.packages.length === 1 ? ' пакет' : ' пакети') + ' · від ' +
                         fmtMoney(Math.min(...p.packages.map(k => k.price_month)), p.packages[0].ccy) + '/міс'}
                  sx={{ bgcolor: 'transparent', color: C.warn, border: `1px solid ${C.warn}` }} />
              )}
              {facts.map(([i, txt, col]) => (
                <Typography key={i} sx={{ fontSize: 12.5, color: col || C.dim, whiteSpace: 'nowrap' }}>{i} {txt}</Typography>
              ))}
              <Box sx={{ flex: 1 }} />
              <IncomeBadge p={p} />
              {isOpen && (
                <Box data-guide="link-on" onClick={e => e.stopPropagation()} sx={{ display: 'flex', alignItems: 'center', pl: .8 }}>
                  <Typography sx={{ fontSize: 12, color: C.dim }}>🔗 посилання для учнів</Typography>   {/* [D-470] */}
                  <Switch checked={!!p.active}
                    onChange={e => (e.target.checked ? enableLink(p) : patch(p.id, { active: false }).catch(() => {}))}
                    sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: C.neon },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: C.neon, opacity: .45 } }} />
                </Box>
              )}
            </Box>

            {isOpen && (<>
            {p.setup && <PartnerSetupGuide p={p} onRefresh={load} />}   {/* [D-558] веде, доки партнера не налаштовано повністю */}
            {!p.active && (
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: .8, flexWrap: 'wrap' }}>
                <Typography sx={{ fontSize: 11.5, color: C.coral, flex: 1, minWidth: 220 }}>
                  🔗 Посилання для учнів (t.me/…?start=pt_код) ще вимкнене — бот за ним нікого не прив'яже.
                  Спершу налаштуйте, що бачать учні, потім відкрийте посилання. Це не «Посилення»: тут лише вхід для учнів.
                </Typography>
                <Button size="small" variant="contained" data-guide="link-btn"
                  onClick={() => enableLink(p)}
                  sx={{ bgcolor: C.neon, color: '#04121a', textTransform: 'none', fontWeight: 700, fontSize: 12 }}>
                  🔗 Відкрити посилання для учнів
                </Button>
              </Box>
            )}

            {/* [D-448] тематичні кнопки — без гортання */}
            <Box sx={{ display: 'flex', gap: .8, flexWrap: 'wrap', mt: 1.4 }}>
              {TABS.map(([k, lbl]) => (
                <Button key={k} size="small" data-guide={'tab-' + k} onClick={() => openTab(p, k)}
                  variant={t === k ? 'contained' : 'outlined'}
                  sx={{ textTransform: 'none', fontSize: 12.5, borderRadius: 5, px: 1.5,
                        borderColor: C.line, color: t === k ? '#04121a' : C.neonTxt,
                        bgcolor: t === k ? C.neon : 'transparent',
                        '&:hover': { bgcolor: t === k ? C.neon : 'rgba(0,229,160,.08)', borderColor: C.neon } }}>
                  {lbl}{k === 'money' && p.sales_pending > 0 ? ` · 💳 ${p.sales_pending}` : ''}{k === 'users' ? ` (${p.users_count})` : ''}{k === 'users' && p.new_count > 0 ? ` · 🆕 ${p.new_count}` : ''}{k === 'ref' ? (p.ref_enabled ? ' · вкл' : ' · викл') : ''}
                </Button>
              ))}
            </Box>

            {t && (
              <Box sx={{ mt: 2, pt: 2, borderTop: `1px solid ${C.line}` }}>
                {BODY[t](p)}
              </Box>
            )}
            </>)}
          </Paper>
        );
      })}

      <PartnerUserCard
        open={!!card}
        userId={card && card.uid}
        loadUser={(uid) => api.get(`/partners/${card.pid}/users/${uid}`).then(r => r.data)}
        loadFeats={(uid) => api.get(`/users/${uid}/features`).then(r => (r.data && r.data.rows) || [])}
        setFeat={(uid, key, st) => api.post(`/users/${uid}/features?key=${encodeURIComponent(key)}&state=${st}`)
          .then(r => (r.data && r.data.rows) || [])}
        setLimit={(uid, n) => api.post(`/users/${uid}/daily-limit?limit=${n}`)}   // [D-589] «🎬 Відео на день» - редагується
        loadPrices={(uid) => api.get(`/partners/${card.pid}/users/${uid}/prices`).then(r => (r.data && r.data.rows) || [])}   // [D-619] своя ціна
        loadMoney={(uid) => api.get(`/partners/${card.pid}/users/${uid}/money`).then(r => r.data)}   // [D-676] історія фінансів учня
        loadSim={(uid) => api.get(`/users/${uid}/similarity`).then(r => (r.data && r.data.rows) || [])}   // [D-701] «🔬 Схожість» - лише тут (дашборд OWNER)
        setPrice={(uid, package_id, price) => api.post(`/partners/${card.pid}/users/${uid}/prices`, { package_id, price })}
        onClose={() => setCard(null)}
        onOpenFull={(uid) => navigate(`/users/${uid}`)}
        onDelete={(uid) => deleteStudent(card.pid, uid)}   // [D-460] для повторних тестів
        onUnbind={(uid) => {   // [D-452] G13
          if (!window.confirm('Відв\'язати цього юзера від партнера? Він стане вашим звичайним юзером, особисті налаштування партнера й пакета знімуться.')) return;
          api.post(`/partners/${card.pid}/users/${uid}/unbind`)
            .then(() => { setToast('Юзера відв\'язано'); const pid0 = card.pid; setCard(null); loadUsers(pid0); load(); })
            .catch(e => setErr(failMsg(e)));
        }}
      />

      {/* [D-559] перевести наявного клієнта власника до партнера: хто це, що лишиться, що зміниться */}
      <Dialog open={!!bind} onClose={() => !(bind && bind.busy) && setBind(null)} maxWidth="md" fullWidth
              PaperProps={{ 'data-pt-bind-dlg': 1, sx: { bgcolor: '#101a24', backgroundImage: 'none', border: '1px solid ' + C.line, color: C.txt } }}>
        {bind && (() => {
          const u = bind.d.user, pp = bind.d.partner, f = bind.d.feat || { before: 0, after: 0, gain: [], lost: [] };
          const acc = u.kind === 'unlimited' ? '♾ безліміт' : u.kind === 'paid' ? 'оплачений до ' + fmtDate(u.until)
            : u.kind === 'trial' ? 'тріал до ' + fmtDate(u.until) : (u.until ? 'закінчився ' + fmtDate(u.until) : 'немає');
          const card = { p: 1.1, borderRadius: 2, bgcolor: 'rgba(255,255,255,.04)' };
          const chip = (bg, col) => ({ px: 1, py: .4, borderRadius: 5, fontSize: 12, bgcolor: bg, color: col, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' });
          return (<>
            <DialogTitle sx={{ pb: 1 }}>➕ Перевести {u.who} до «{pp.name}»</DialogTitle>
            <DialogContent>
              <Box sx={{ display: 'grid', gap: .8, gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', mb: 1.5 }}>
                {[['👤 клієнт', u.who + (u.username ? ' · ID ' + u.tg_id : '')], ['🔑 доступ', acc], ['📦 пакет', u.package_name || '—'], ['🎬 відео', u.total_videos]].map(([l, v]) => (
                  <Box key={l} sx={card}>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis' }}>{v}</Typography>
                    <Typography sx={{ fontSize: 11.5, color: C.dim }}>{l}</Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={{ display: 'grid', gap: .8, gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', mb: 1.5 }}>
                <Box data-pt-bind-keep="1" sx={{ ...card, borderTop: `3px solid ${C.neon}` }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.neonTxt, mb: .4 }}>✅ Лишиться як є</Typography>
                  <Typography sx={{ fontSize: 12.5, lineHeight: 1.5 }}>
                    Доступ ({acc}), денний ліміт, історія відео й особисті налаштування. Клієнтові бот нічого не напише.
                  </Typography>
                </Box>
                <Box data-pt-bind-change="1" sx={{ ...card, borderTop: '3px solid #ffd166' }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#ffd166', mb: .4 }}>🔁 Зміниться</Typography>
                  <Typography sx={{ fontSize: 12.5, lineHeight: 1.5 }}>
                    Після відео — одна кнопка «🎬 Відкрити Студію». Бачитиме те, що показано цьому партнеру.
                    Наступну оплату робитиме пакетами партнера ({pp.pkgs}) — гроші діляться за його часткою.
                  </Typography>
                </Box>
              </Box>
              <Typography data-pt-bind-count="1" sx={{ fontSize: 13, fontWeight: 700, mb: .6 }}>
                🧩 Функцій і кнопок: зараз бачить {f.before} → бачитиме {f.after}
              </Typography>
              {f.gain.length > 0 && (
                <Box sx={{ display: 'grid', gap: .6, gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))', mb: 1 }}>
                  {f.gain.map(t => <Box key={t} title={t} data-pt-bind-gain="1" sx={chip('rgba(0,229,160,.14)', C.neonTxt)}>＋ {t}</Box>)}
                </Box>
              )}
              {f.lost.length > 0 && (<>
                <Typography sx={{ fontSize: 12, color: C.dim, mb: .5 }}>Зникне (наведіть на розділ — побачите назви):</Typography>
                <Box sx={{ display: 'grid', gap: .6, gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))', mb: 1 }}>
                  {f.lost.map(x => <Box key={x.area} title={x.titles.join('\n')} data-pt-bind-lost={x.titles.length} sx={chip('rgba(255,122,89,.14)', C.coral)}>− {x.area} · {x.titles.length}</Box>)}
                </Box>
              </>)}
              <Typography sx={{ fontSize: 12, color: C.dim, mb: 1 }}>
                Потрібну кнопку можна повернути цьому клієнтові особисто: його картка тут же → функції. Скасувати все: картка учня → «Відв'язати від партнера».
              </Typography>
              {(bind.d.warn || []).map(w => (
                <Typography key={w} data-pt-bind-warn="1" sx={{ fontSize: 12.5, color: '#ffd166', mb: .5 }}>⚠️ {w}</Typography>
              ))}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: .5, mt: .5 }}>
                <Switch size="small" checked={!!bind.notify} onChange={e => { const v = e.target.checked; setBind(x => ({ ...x, notify: v })); }} />
                <Typography sx={{ fontSize: 12.5, color: C.dim }}>написати партнерові в Telegram, що в нього новий учень</Typography>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setBind(null)} disabled={bind.busy} sx={{ textTransform: 'none', color: C.dim }}>Скасувати</Button>
              <Button variant="contained" data-pt-bind-go="1" onClick={bindDo} disabled={bind.busy}
                sx={{ textTransform: 'none', bgcolor: C.neon, color: '#04121a', fontWeight: 700, '&:hover': { bgcolor: C.neon } }}>
                {bind.busy ? 'Переводжу…' : '✅ Перевести до «' + pp.name + '»'}
              </Button>
            </DialogActions>
          </>);
        })()}
      </Dialog>

      {/* [D-467] повне видалення партнера */}
      <Dialog open={!!purge} onClose={() => !(purge && purge.busy) && setPurge(null)} maxWidth="sm" fullWidth
              PaperProps={{ sx: { bgcolor: '#101a24', backgroundImage: 'none', border: '1px solid ' + C.coral, color: C.txt } }}>
        {purge && (<>
          <DialogTitle>🗑 Видалити «{purge.preview.name}» повністю</DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'grid', gap: .8, gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', mb: 2 }}>
              {[['👥 учнів', purge.preview.counts.students], ['💳 оплат', purge.preview.counts.sales + (purge.preview.counts.sales_approved ? ` (підтв. ${purge.preview.counts.sales_approved})` : '')],
                ['🔁 переказів', purge.preview.counts.settlements], ['🧾 витрат', purge.preview.counts.costs], ['📦 пакетів', purge.preview.counts.packages],
                ['🔑 акаунтів кабінету', purge.preview.counts.accounts], ['📜 подій журналу', purge.preview.counts.audit], ['🤖 запитів ШІ', purge.preview.counts.ai_calls]].map(([l, v]) => (
                <Box key={l} sx={{ p: 1, borderRadius: 2, bgcolor: 'rgba(255,255,255,.04)' }}>
                  <Typography sx={{ fontSize: 18, fontWeight: 800 }}>{v}</Typography>
                  <Typography sx={{ fontSize: 11.5, color: C.dim }}>{l}</Typography>
                </Box>
              ))}
            </Box>
            {purge.preview.topics.length > 0 && (<>
              <Typography sx={{ fontSize: 13, fontWeight: 700, mb: .6 }}>Гілки партнера в групі ({purge.preview.topics.length}):</Typography>
              <Box sx={{ display: 'flex', gap: .8, flexWrap: 'wrap', mb: 2 }}>
                {[['delete', '🗑 видалити з історією'], ['close', '🔒 закрити (історія лишиться)'], ['keep', 'лишити як є']].map(([k, l]) => (
                  <Button key={k} size="small" variant={purge.topics === k ? 'contained' : 'outlined'} onClick={() => setPurge(x => ({ ...x, topics: k }))}
                    sx={{ textTransform: 'none', borderColor: C.line, color: purge.topics === k ? '#04121a' : C.neonTxt, bgcolor: purge.topics === k ? C.neon : 'transparent' }}>{l}</Button>
                ))}
              </Box>
            </>)}
            <Typography sx={{ fontSize: 12.5, color: C.coral, mb: 1 }}>
              Це не скасувати. Свої акаунти партнера стираються лише якщо це «чисто ботові» записи (не платили вам і не обробляли відео).
            </Typography>
            <TextField size="small" fullWidth autoFocus placeholder={`впишіть «${purge.preview.name}» для підтвердження`} value={purge.confirm}
              onChange={e => { const v = e.target.value; setPurge(x => ({ ...x, confirm: v })); }} inputProps={inProps} sx={fieldSx} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPurge(null)} disabled={purge.busy} sx={{ textTransform: 'none', color: C.dim }}>Скасувати</Button>
            <Button variant="contained" onClick={doPurge} disabled={purge.busy || purge.confirm.trim() !== purge.preview.name}
              sx={{ textTransform: 'none', bgcolor: C.coral, color: '#fff', fontWeight: 700, '&:hover': { bgcolor: '#e0603f' } }}>
              {purge.busy ? 'Видаляю…' : '🗑 Видалити назавжди'}
            </Button>
          </DialogActions>
        </>)}
      </Dialog>
      </>)}
      <Snackbar open={!!toast} autoHideDuration={2200} onClose={() => setToast('')}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="success" variant="filled">{toast}</Alert>
      </Snackbar>
      <Snackbar open={!!err} autoHideDuration={4000} onClose={() => setErr('')}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="error" variant="filled">{err}</Alert>
      </Snackbar>
    </Box>
  );
}
